export const ELEMENTS_LIST = [
    {
        name: "Free text",
        tag: "free_text",
        types: [
            "inventory", "box", "pallet", "text"
        ],
        sample: "Sample text"
    },
    {
        name: "Partner logo",
        tag: "partner_logo",
        types: [
            "inventory", "box", "pallet", "text"
        ],
        sample: "/assets/images/logo.png"
    },
    {
        name: "Partner name",
        tag: "partner_name",
        types: [
            "inventory", "box", "pallet", "text"
        ],
        sample: "ACME INC"
    },
    // {
    //     name: "Order: [ref]",
    //     tag: "order_ref",
    //     types: [
    //         "inventory", "box", "pallet"
    //     ],
    //     sample: "ORD45751"
    // },
    // {
    //     name: "Order ref barcode",
    //     tag: "order_ref_bc",
    //     types: [
    //         "inventory", "box", "pallet"
    //     ]
    // },
    {
        name: "Item: [name]",
        tag: "item",
        types: [
            "inventory", "box", "pallet"
        ],
        sample: "HDD-120-DSL-S3H"
    },
    {
        name: "Item barcode",
        tag: "item_bc",
        types: [
            "inventory", "box", "pallet"
        ]
    },
    {
        name: "Item description",
        tag: "item_description",
        types: [
            "inventory", "box", "pallet"
        ],
        sample: "HDD 120 GB SATA-3 2.5-inch, non-volatile storage device"
    },
    {
        name: "Item quantity",
        tag: "item_qty",
        types: [
            "inventory", "box", "pallet"
        ],
        sample: "99999"
    },
    {
        name: "Item quantity barcode",
        tag: "item_qty_bc",
        types: [
            "inventory", "box", "pallet"
        ]
    },
    {
        name: "Serial: [name]",
        tag: "serial",
        types: [
            "inventory"
        ],
        sample: "SN2885155"
    },
    {
        name: "Serial barcode",
        tag: "serial_bc",
        types: [
            "inventory"
        ]
    },
    {
        name: "Batch: [name]",
        tag: "batch",
        types: [
            "inventory"
        ],
        sample: "b4312"
    },
    {
        name: "Batch barcode",
        tag: "batch_bc",
        types: [
            "inventory"
        ]
    },
    {
        name: "Rev: [name]",
        tag: "rev",
        types: [
            "inventory"
        ],
        sample: "v3.0.1"
    },
    {
        name: "Rev barcode",
        tag: "rev_bc",
        types: [
            "inventory"
        ]
    },
    {
        name: "Lot: [name]",
        tag: "lot",
        types: [
            "inventory"
        ],
        sample: "LT24"
    },
    {
        name: "Lot barcode",
        tag: "lot_bc",
        types: [
            "inventory"
        ]
    },
    {
        name: "Conf: [name]",
        tag: "configurations",
        types: [
            "inventory"
        ],
        sample: "ELT241344655"
    },
    {
        name: "Config barcode",
        tag: "configurations_bc",
        types: [
            "inventory"
        ]
    },
    {
        name: "Box: [ref]",
        tag: "box_ref",
        types: [
            "inventory", "box"
        ],
        sample: "BOX-25542"
    },
    {
        name: "Box ref barcode",
        tag: "box_ref_bc",
        types: [
            "inventory", "box"
        ]
    },

    {
        name: "Box serials",
        tag: "box_serial_list",
        types: [
            "box"
        ],
        sample: [
            "SN0000001",
            "SN0000002",
            "SN0000003",
            "SN0000004",
            "SN0000005",
            "SN0000006",
            "SN0000007",
            "SN0000008",
            "SN0000009",
            "SN0000010",
            "SN0000011",
            "SN0000012",
            "SN0000013",
            "SN0000014",
            "SN0000015",
            "SN0000016",
            "SN0000017",
            "SN0000018",
            "SN0000019",
            "SN0000020"
        ]
    },
    {
        name: "Box serials w/ barcode",
        tag: "box_serial_list_bc",
        types: [
            "box"
        ],
        sample: [
            "SN0000001",
            "SN0000002",
            "SN0000003",
            "SN0000004",
            "SN0000005",
            "SN0000006",
            "SN0000007",
            "SN0000008",
            "SN0000009",
            "SN0000010",
            "SN0000011",
            "SN0000012",
            "SN0000013",
            "SN0000014",
            "SN0000015",
            "SN0000016",
            "SN0000017",
            "SN0000018",
            "SN0000019",
            "SN0000020"
        ]
    },

    {
        name: "Pallet/OB: [ref]",
        tag: "pallet_ref",
        types: [
            "inventory", "box", "pallet"
        ],
        sample: "158FDHF234567890"
    },
    {
        name: "Pallet ref barcode",
        tag: "pallet_ref_bc",
        types: [
            "inventory", "box", "pallet"
        ]
    },

    {
        name: "Pallet boxes",
        tag: "pallet_box_list",
        types: [
            "pallet"
        ],
        sample: [
            "BOX0000001",
            "BOX0000002",
            "BOX0000003",
            "BOX0000004",
            "BOX0000005",
            "BOX0000006",
            "BOX0000007",
            "BOX0000008",
            "BOX0000009",
            "BOX0000010",
            "BOX0000011",
            "BOX0000012",
            "BOX0000013",
            "BOX0000014",
            "BOX0000015",
            "BOX0000016",
            "BOX0000017",
            "BOX0000018",
            "BOX0000019",
            "BOX0000020"
        ]
    },
    {
        name: "Pallet boxes w/ barcode",
        tag: "pallet_box_list_bc",
        types: [
            "pallet"
        ],
        sample: [
            "BOX0000001",
            "BOX0000002",
            "BOX0000003",
            "BOX0000004",
            "BOX0000005",
            "BOX0000006",
            "BOX0000007",
            "BOX0000008",
            "BOX0000009",
            "BOX0000010",
            "BOX0000011",
            "BOX0000012",
            "BOX0000013",
            "BOX0000014",
            "BOX0000015",
            "BOX0000016",
            "BOX0000017",
            "BOX0000018",
            "BOX0000019",
            "BOX0000020"
        ]
    },


    {
        name: "Location: [name]",
        tag: "location",
        types: [
            "inventory", "box", "pallet"
        ],
        sample: "Shelf-1"
    },
    {
        name: "Location barcode",
        tag: "location_bc",
        types: [
            "inventory", "box", "pallet"
        ]
    },
    {
        name: "Warehouse name",
        tag: "wh",
        types: [
            "inventory", "box", "pallet", "text"
        ],
        sample: "ACME Warehouse"
    },
    {
        name: "Hub name",
        tag: "hub",
        types: [
            "inventory", "box", "pallet"
        ],
        sample: "ACME Hub Good"
    }
];